import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzFloatButtonModule } from 'ng-zorro-antd/float-button';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';

@Component({
  selector: 'app-website-layout',
  templateUrl: './website-layout.component.html',
  imports: [
    HeaderComponent,
    FooterComponent,
    RouterModule,
    NzFloatButtonModule,
    CommonModule,
  ],
})
export class WebsiteLayoutComponent {}
